import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DDLDataTable } from "../DDLDataTable";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { PayrollService } from "../../services/PayrollService";
import { TimeSheetCategoriesSetupValidationSchema } from "./validator";
import { TimeSheetCategoriesToolbar } from "./TimeSheetCategoriesToolbar";
import { TimeSheetCategoryFieldsTable } from "./TimeSheetCategoryFieldsTable/TimeSheetCategoryFieldsTable";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { useNavigateToLogout } from "../../common/Common";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";




export interface ITimeSheetCategories { }
const SINGLE_RECORD_DATA_QUERY_KEY = "timesheet-categories-single-data-record";
const TIMESHEET_CATEGORIES_DATA_QUERY_KEY = "timesheet-categories-list";
const SELECT_CATEGORY_DLL = "select-category-ddl";

// const useTimeSheetCategories = (
// 	clientId: string,
// 	params: IGetListRequest,
// 	navigateToLogout: (path: string) => void
// ) =>
// 	useQuery({
// 		queryKey: [TIMESHEET_CATEGORIES_DATA_QUERY_KEY, clientId, params],
// 		queryFn: (data) => {

// 			return PayrollService.getTimeSheetCategories(
// 				clientId,
// 				params,
// 				navigateToLogout
// 			);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

const useGetDataTimeSheetCategoryById = (
	// id: string | undefined,
	clientId: string,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, clientId, navigateToLogout],
		queryFn: () => {
			return PayrollService.getTimeSheetCategoriesById(clientId, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetSelectCategoryDDL = (clientId: string) =>
	useQuery({
		queryKey: [SELECT_CATEGORY_DLL],
		queryFn: () => {
			return PayrollService.getSelectCategoryDDL(
				clientId,
			);
		},
		refetchOnWindowFocus: false,
	});

export let categoryItemsInitialData = [
	{ id: "1", title: null, required: false, status: 100, dataInput: 100 },
	{ id: "2", title: null, required: false, status: 100, dataInput: 100 },
	{ id: "3", title: null, required: false, status: 100, dataInput: 100 },
	{ id: "4", title: null, required: false, status: 100, dataInput: 100 },
	{ id: "5", title: null, required: false, status: 100, dataInput: 100 },
]

export const TimeSheetCategories: React.FC<ITimeSheetCategories> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [timeSheetCategoriesId, setTimeSheetCategoriesId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [categoryTableUpdatedData, setCategoryTableUpdatedData] =
		useState(categoryItemsInitialData);
	const [categoryFieldsDataItems, setCategoryFieldsDataItems] =
		useState(categoryItemsInitialData);
	// const [deletedRowId, setDeletedRowId] = useState<any>(undefined);
	const [selectedDeleteRow, setSelectedDeleteRow] = useState<any>(null);
	const [deletedRowTitle, setDeletedRowTitle] = useState<string>("");

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "title",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "title",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending: isPendingSelecteCategoryDDL, data: selecteCategoryDDL } =
		useGetSelectCategoryDDL(clientId);

	const { isPending: isPendingById, data: selectedDataRecord } = useGetDataTimeSheetCategoryById(
		clientId,
		navigateToLogout
	);


	// const { isPending, data } = useTimeSheetCategories(
	// 	clientId,
	// 	queryParams,
	// 	navigateToLogout
	// );

	// const TimeSheetCategoriesList: any | null = data;

	const { isPending: isSubmitting, mutate: submitTimeSheetCategoriesFormFields } =
		useMutation({
			mutationFn: PayrollService.createTimeSheetCategories,
			onSuccess: (res: ITimeSheetCategories | IServerError | IResponse | any) => {

				if (res.status === 200) {

					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/settings/timesheet/category/${res.data.clientId}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [TIMESHEET_CATEGORIES_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {

					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/settings/timesheet/category/${res.data.clientId}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [TIMESHEET_CATEGORIES_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});


	const updatedTimeSheetCategoriesListItems = useMemo(() => {
		return (
			selecteCategoryDDL &&
			selecteCategoryDDL.items &&
			selecteCategoryDDL?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/settings/timesheet/category/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.label}
					</Link>
				),
			}))
		);
	}, [selecteCategoryDDL]);

	const formMethods = useForm<any>({
		resolver: yupResolver(TimeSheetCategoriesSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const onSubmit = (values: any) => {
		const formatTimeSheetCategoryItemsData =
			categoryTableUpdatedData &&
			categoryTableUpdatedData
				.filter((x: any) => x.title && x.title.trim() !== "").map((x: any) => ({
					...x,
					id: undefined,
					// title: x.title,
					// required: values[`required_${x.title}`] ?? x.required,
					// status: x.status,
					// dataInput: x.dataInput,
				}));

		console.log("Formatted Payload", formatTimeSheetCategoryItemsData);

		let payload = {
			clientId: clientId,
			categories: formatTimeSheetCategoryItemsData,
			navigateToLogout: navigateToLogout,
		};
		console.log("values", values);
		console.log("Payload", payload);
		submitTimeSheetCategoriesFormFields(payload);
	};

	useEffect(() => {
		if (clientId && selectedDataRecord) {
			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "clientId") {
					let path = `/settings/timesheet/category/${clientId}`
					navigate(path)
				}
				if (fieldName === 'categories' && Array.isArray(fieldValue) && fieldValue?.length) {
					// const markedRows = fieldValue.map((category: any) => ({
					// 	...category,
					// 	// categoryTrackingSave: true,
					// 	categoryTrackingSave: category.categoryTrackingSave ?? false,
					// }));
					setCategoryFieldsDataItems(fieldValue);
					setCategoryTableUpdatedData(fieldValue);

					// fieldValue.forEach((category: any) => {
					// 	formMethods.setValue(
					// 		!category.id ? `required_${category.title}` : `required_${category.id}`,
					// 		category.required ?? false
					// 	);
					// });
				} else if (fieldName === 'categories' && Array.isArray(fieldValue) && fieldValue?.length === 0) {
					setCategoryFieldsDataItems(categoryItemsInitialData);
					setCategoryTableUpdatedData(categoryItemsInitialData);
				}
			});
		}
	}, [clientId, selectedDataRecord]);
	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};


	const { isPending: isDeleting, mutate: deletedTimeSheetCategoryById } = useMutation({
		mutationFn: PayrollService.deleteTimeSheetCategory,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				formMethods.reset();
				let path = `/settings/timesheet/category/${clientId}`;
				navigate(path);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			return queryClient.invalidateQueries({
				queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setTimeSheetCategoriesId(params.id);
	}, []);

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		setCategoryFieldsDataItems([...categoryItemsInitialData.map((item) => ({ ...item }))]);
		setCategoryTableUpdatedData([...categoryItemsInitialData.map((item) => ({ ...item }))]);
		let path = `/settings/timesheet/category`;
		navigate(path);
	};

	const deleteTimeSheetCategoryTableField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				clientId: clientId,
				category: selectedDeleteRow,
				// title: deletedRowTitle,
				navigateToLogout: navigateToLogout,
			};
			deletedTimeSheetCategoryById(delPayload);
			setDialogOpen(false);
		}
	};
	const onDeleteClicked = (params: any) => {
		setSelectedDeleteRow(params);
		// setDeletedRowTitle(params.title);
		setDialogOpen(true);
		setSingleDelete(true);
		console.log('paramasssssssssssss', params);
	};

	// const onDeleteClicked = (params: any) => {
	// 	setDeletedRowId(params.id)
	// 	console.log('paramasssssssssssss', params)
	// 	setDialogOpen(true);
	// 	setSingleDelete(true);
	// 	// if (selectedDataRecord.categoryItems) {
	// 	// 	setSelectedEmployeeId(selectedDataRecord.employeeId);
	// 	// }
	// 	setEditRecordId(params.id); // checkkkkkkkkkkkk later id is correct or not///
	// };

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const expandedLabels = ["Settings", "Time Sheet"];
	const expandedTimeSheetCategoriesSetupOrSetupItem = "Category"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Time Sheet" &&
				item.label === expandedTimeSheetCategoriesSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedTimeSheetCategoriesSetupOrSetupItem && "/settings/timesheet/category",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: ITimeSheetCategories | any) => {
		let path = `/settings/timesheet/category/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid>
			<BackdropCircularProgress
				open={isSubmitting || isDeleting || isPendingById || isPendingSelecteCategoryDDL}
				testId="time-sheet-categories-Setup"
			/>

			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteTimeSheetCategoryTableField}
				cancelActionHandler={onCloseHandler}
				testId="timeSheet-Category-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Categories"
										testId={`time-sheet-categories`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
										borderHide={true}
									>
										<TimeSheetCategoryFieldsTable
											categoryTableUpdatedData={(data: any) =>
												setCategoryTableUpdatedData(data)
											}
											categoryFieldsDataItems={categoryFieldsDataItems}
											onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
											showIndexColumn={true}

										/>
									</StandardPanel>
								}
								toolbar={
									<TimeSheetCategoriesToolbar
										onResetClicked={onResetClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 3, lg: 3, xl: 3 }}></Grid>
						{/* <Grid
							size={{ xs: 12, sm: 12, md: 3.4, lg: 3.4, xl: 3.4 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									updatedTimeSheetCategoriesListItems
										? updatedTimeSheetCategoriesListItems
										: []
								}
								showHeaderColumns={true}
								showPaginator={false}
								// onRowEditClicked={onRowEditClicked}
								// onRowDeleteClicked={onRowDeleteClicked}

								// isLoading={isPending}
								// totalRecords={
								// 	TimeSheetCategoriesList && TimeSheetCategoriesList.total
								// 		? TimeSheetCategoriesList.total
								// 		: 0
								// }
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								// showPaginator={false}
								selectedId={selectedDataRecord && id && selectedDataRecord.employeeId}

							/>
						</Grid> */}
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"time-sheet-categories-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
